const TRACKING_SERVER = 'http://123.207.50.250:8082/trackIndex.htm';

function initOrderTracking() {
  const searchBtn = document.getElementById('SearchBtn');
  const trackingInput = document.getElementById('TrackingNumber');

  if (!searchBtn || !trackingInput) return;

  searchBtn.addEventListener('click', searchTracking);
  trackingInput.addEventListener('keypress', (e) => {
    if (e.key === 'Enter') searchTracking();
  });
}

async function searchTracking() {
  const trackingNumber = document.getElementById('TrackingNumber').value.trim();

  if (!trackingNumber) {
    showError('אנא הזינו מספר מעקב');
    return;
  }

  showLoading();

  try {
    const response = await fetch(TRACKING_SERVER, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: `documentCode=${encodeURIComponent(trackingNumber)}`
    });

    if (!response.ok) {
      throw new Error('שגיאה בקשר לשרת מעקב');
    }

    const html = await response.text();
    displayTrackingFromHTML(html, trackingNumber);
  } catch (error) {
    console.error('Tracking error:', error);
    showError('שגיאה בשליפת מידע מעקב. אנא נסו שוב מאוחר יותר.');
  }
}

function displayTrackingFromHTML(html, trackingNumber) {
  // Create a temporary container to parse HTML
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');

  // Extract tracking info from HTML
  const trackingRows = doc.querySelectorAll('tr');

  if (trackingRows.length === 0) {
    showError('לא נמצא מידע עבור מספר מעקב זה');
    return;
  }

  document.getElementById('TrackingNumberDisplay').textContent = trackingNumber;
  document.getElementById('CarrierDisplay').textContent = 'שרת מעקב';

  // Build timeline from HTML table rows
  const timelineContainer = document.getElementById('TimelineContainer');
  timelineContainer.innerHTML = '';

  let lastStatus = 'בעיבוד';
  let hasData = false;

  trackingRows.forEach((row) => {
    const cells = row.querySelectorAll('td');
    if (cells.length >= 2) {
      hasData = true;
      const time = cells[0]?.textContent?.trim() || '';
      const location = cells[1]?.textContent?.trim() || '';
      const status = cells[2]?.textContent?.trim() || '';

      if (time && location) {
        lastStatus = status || location;
        const eventEl = document.createElement('div');
        eventEl.className = 'tracking-event';
        eventEl.innerHTML = `
          <div class="tracking-event__dot"></div>
          <div class="tracking-event__content">
            <div class="tracking-event__location">${location}</div>
            <div class="tracking-event__status">${status || ''}</div>
            <div class="tracking-event__time">${time}</div>
          </div>
        `;
        timelineContainer.appendChild(eventEl);
      }
    }
  });

  if (!hasData) {
    showError('לא ניתן להציג מידע עבור מספר זה');
    return;
  }

  // Set status
  document.getElementById('StatusText').textContent = lastStatus;
  document.getElementById('StatusTime').textContent = 'עדכון מהשרת';

  // Set badge
  const statusBadge = document.getElementById('StatusBadge');
  const statusLower = lastStatus.toLowerCase();
  if (statusLower.includes('delivered') || statusLower.includes('קבול')) {
    statusBadge.className = 'tracking-status__badge badge-delivered';
    statusBadge.textContent = 'הוסלם';
  } else if (statusLower.includes('exception') || statusLower.includes('בעיה')) {
    statusBadge.className = 'tracking-status__badge badge-exception';
    statusBadge.textContent = 'בעיה';
  } else {
    statusBadge.className = 'tracking-status__badge badge-in-transit';
    statusBadge.textContent = 'בדרך';
  }

  showSuccess();
}

function showLoading() {
  document.getElementById('TrackingResults').style.display = 'block';
  document.getElementById('LoadingState').style.display = 'block';
  document.getElementById('ErrorState').style.display = 'none';
  document.getElementById('SuccessState').style.display = 'none';
}

function showError(message) {
  document.getElementById('TrackingResults').style.display = 'block';
  document.getElementById('LoadingState').style.display = 'none';
  document.getElementById('ErrorState').style.display = 'block';
  document.getElementById('SuccessState').style.display = 'none';
  document.getElementById('ErrorMessage').textContent = message;
}

function showSuccess() {
  document.getElementById('TrackingResults').style.display = 'block';
  document.getElementById('LoadingState').style.display = 'none';
  document.getElementById('ErrorState').style.display = 'none';
  document.getElementById('SuccessState').style.display = 'block';
}

document.addEventListener('DOMContentLoaded', initOrderTracking);
